<div class="pending-approvals-page">
  <div class="pending-approvals-header">
    <div stack-layout gap="xs" class="pending-approvals-title-block">
      <Text role="headline-large">Pending Approvals</Text>
      <Text role="body-medium" color="on-background-variant">
        RMAs awaiting your review and decision.
      </Text>
    </div>

    <div class="pending-approvals-back">
      <button text-button variant="ghost" size="md" (click)="goBackToSummary()">
        Back
      </button>
    </div>
  </div>

  <DataTable [datasource]="datasource" [columns]="columns">
    <div ngProjectAs="data-table-footer" stack-layout gap="md">
      <div class="pending-approvals-footer" stack-layout gap="sm">
        <Text>{{ datasource.recordCount() }} Pending RMAs</Text>
        <div class="pending-approvals-pagination-center">
          <Paginator [datasource]="datasource" [initPageSize]="10" />
        </div>
      </div>
    </div>
  </DataTable>
</div>

<ng-template #rmaNumberCell let-rmaNumber="rmaNumber" let-rmaId="rmaId">
  <a class="rma-id-link" href="" (click)="$event.preventDefault(); openRmaDetails(rmaId)">
    {{ rmaNumber }}
  </a>
</ng-template>

<ng-template #statusCell let-status="status">
  <span class="rma-status-chip" [class]="getStatusClass(status)">
    <span class="rma-status-dot" aria-hidden="true"></span>
    {{ status || '-' }}
  </span>
</ng-template>
